module.exports = __webpack_public_path__ + "static/media/verset_2Tim2.660b6de9.svg_old";